<template>
  <div class="item" @click="goToProject">
    <div class="header">
      <div class="header-click-expanded">
        <div class="folder-icon"></div>
        <div class="name">{{project.name}}</div>
        <div class="date">{{project.creationTimestamp | formatDate}}</div>
        <project-card-trials-steps :trialList="project.trials"></project-card-trials-steps>
        <div class="trials-title">{{project.trials.length}} {{$t('trials')}}</div>
        <project-card-status :status="project.status"></project-card-status>
        <div :class="['toggle-button', {'open': expanded}]"  @click.stop="expanded=!expanded"></div>
      </div>
      <project-action-menu :project="project"></project-action-menu>
    </div>
    <div class="body" :class="{'open': expanded}">
      <div class="content">
        <div class="description">
          <div>{{project.description}}</div>
          <input-container
            v-for="(field,i) in relevantFields"
            ref="input"
            :key="field.name"
            v-model="relevantFields[i]"
            :readOnly="true"
            class="project-description-item"
          />
        </div>
        <!--<div class="link">
          <router-link :to="'/project/' + project.id">{{$t('see_details')}}</router-link>
          <div class="link-icon"></div>
        </div>-->
      </div>
      <project-card-trials-list :projectId="project.id" :trialList="project.trials"></project-card-trials-list>
    </div>
  </div>
</template>

<script>
import ProjectActionMenu from '@/components/project/ProjectActionMenu'
import ProjectCardTrialsSteps from '@/components/project/ProjectCardTrialsSteps'
import ProjectCardStatus from '@/components/project/ProjectCardStatus'
import ProjectCardTrialsList from '@/components/project/ProjectCardTrialsList'
import InputContainer from '@/components/inputs/InputContainer'
import projectData from '@/mixins/projectData'

export default {
  name: 'ProjectListItem',
  props: ['project'],
  mixins: [projectData],
  components: {ProjectActionMenu, ProjectCardTrialsSteps, ProjectCardStatus,ProjectCardTrialsList, InputContainer},
  data () {
    return {
      expanded: false
    }
  },
  methods: {
    goToTrial(projectId, trialId) {
      this.$router.push({path: `/project/${projectId}/trial/${trialId}/results`})
    },
    goToProject(evt){
      this.$router.push({path: `/project/${this.project.id}`})
    }
  }
}
</script>

<style lang="stylus" scoped>
$item-content-height = 165px

.item
  background-color: $titan-white
  border-radius: 2px
  display: flex
  flex-direction: column
  margin-left: 90px
  margin-right: 90px
  position: relative
  transition: transform 0.15s ease-in-out
  border 1px solid $titan-white
  &:hover
    //transform: translateX(3px)
    cursor pointer
    //box-shadow: 5px 5px 20px rgba($lynch, 0.5)
    border 1px solid $heather

  &:not(:last-child)
    margin-bottom: 5px

  .header
    align-items: center
    box-shadow: 15px 15px 40px rgba($lynch, 0.25)
    display: flex
    height: 55px
    padding-left: 15px
    padding-right: 15px
    width: 100%

    .header-click-expanded
      align-items: center
      cursor: pointer
      display: flex
      flex: 1 1 0%

      .folder-icon
        m-icon("folder", 19 15)
        // flex: 0 0 auto
        margin-right: 20px

      .name
        m-font-size(16, 20)
        flex: 1 1 0%
        font-weight: $fw-semi-bold

      .date
        color: rgba($cloud-burst, 0.5)
        m-font-size(12, 14)
        // flex: 0 0 auto
        margin-left: 10px

      .project-card-trials-steps
        // flex: 0 0 auto
        margin-left: 10px
        width: 200px

      .trials-title
        // flex: 0 0 auto
        m-font-size(12, 14)
        margin-left: 10px

      .project-card-status
        // flex: 0 0 auto
        margin-left: 10px

      .toggle-button
        margin-left: 10px
        m-icon("toggle-panel-caret", 15)
        transform: rotate(0)
        transition: all 0.3s
        background-size: 12px 13px
        border-radius: 50%
        cursor: pointer
        height: 28px
        width: 28px
        &:hover
          background-color rgba($mystic, 0.5)

        &.open
          transform: rotate(180deg)

    .multiple-actions-menu
      padding: 0 10px

  .body
    display: flex
    height: 0
    overflow: hidden
    transition: height 0.25s ease-in-out

    &.open
      height: $item-content-height

    .content
      display: flex
      flex: 0 0 60%
      flex-direction: column
      height: $item-content-height
      padding: 15px 30px

      .description
        m-font-size(12, 18)
        flex: 1 1 0%
        font-weight: $fw-light
        margin-bottom: 10px
        // overflow: hidden
        overflow-y: auto

      .link
        align-items: center
        display: flex
        flex: 0 0 auto
        margin: 5px 0

        &:hover
          > a
            &:after
              width: 100%

          .link-icon
            transform: translateX(4px)

        > a
          color: $cloud-burst
          position: relative
          text-decoration: none
          m-font-size(12, 14)
          font-weight: $fw-semi-bold

          &:after
            background-color: $cloud-burst
            bottom: -2px
            content: ""
            height: 2px
            left: 0
            position: absolute
            transition: width 0.25s ease-in-out
            width: 0

        .link-icon
          m-icon("arrow-right-cloud-burst", 8 6)
          margin-left: 5px
          transition: transform 0.25s ease-in-out

    .project-card-expanded-trials
      height: $item-content-height

    .project-card-trials-list
      flex: 0 0 50%
      padding: 0 30px
</style>